export default __webpack_public_path__ + "static/media/4h.d2f240cf.png";